import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./app/App";
import { BASE_URL } from "./app/AppConstants";
import configureStore from "./~store/configureStore";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./fonts/Gilroy/stylesheet.css";

const store = configureStore();

createRoot(document.getElementById("root") as HTMLElement)
  .render(
    <Provider store={store}>
      <BrowserRouter basename={BASE_URL} useTransitions={false}>
          <App />
      </BrowserRouter>
    </Provider>
  );